import React from 'react';
interface HeroProps {
  onAddToCart: () => void;
}
export function Hero({
  onAddToCart
}: HeroProps) {
  return <section className="relative min-h-[90vh] flex items-center py-12 md:py-20 px-4 bg-dark-primary overflow-hidden" data-id="element-356">
      {/* Subtle radial gold glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[80%] h-[50%] bg-gold/5 blur-[120px] rounded-full pointer-events-none" data-id="element-357"></div>

      <div className="max-w-content mx-auto relative z-10 w-full" data-id="element-358">
        <div className="flex flex-col md:flex-row items-center gap-12 md:gap-8" data-id="element-359">
          {/* LEFT COLUMN */}
          <div className="w-full md:w-[60%] flex flex-col items-center md:items-start text-center md:text-left" data-id="element-360">
            {/* Badge */}
            <div className="inline-block border border-gold/30 bg-dark-secondary px-3 py-1.5 rounded mb-6" data-id="element-361">
              <span className="font-mono text-[10px] text-gold uppercase tracking-widest" data-id="element-362">
                EBOOK + 3 BONUS EXCLUSIVOS · PDF DIGITAL
              </span>
            </div>

            {/* H1 */}
            <h1 className="font-serif font-black text-5xl md:text-[64px] text-cream leading-[1.05] mb-4 tracking-tight" data-id="element-363">
              El Azúcar Silencioso
            </h1>

            {/* Subtitle */}
            <p className="font-serif italic text-gold text-xl md:text-2xl leading-snug mb-6 max-w-lg" data-id="element-364">
              La glicación: el proceso invisible que ocurre dentro de tu cuerpo
              y que pocos explican
            </p>

            {/* Subheadline */}
            <p className="font-sans text-gray-warm text-[17px] md:text-[18px] leading-relaxed mb-8 max-w-lg" data-id="element-365">
              Descubre lo que el azúcar está haciendo en silencio dentro de tu
              cuerpo, algo que mucha gente con problemas de azúcar en la sangre
              no ve venir. Sin dietas extremas. Solo ciencia clara y práctica.
            </p>

            {/* Trust Badges */}
            <div className="flex flex-col sm:flex-row items-center md:items-start gap-4 sm:gap-6 mb-10 font-sans text-sm text-gray-warm" data-id="element-366">
              <span className="flex items-center gap-2" data-id="element-367">
                <svg className="w-4 h-4 text-gold" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-368">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" data-id="element-369" />
                </svg>
                PDF digital · descarga en 1 minuto
              </span>
              <span className="flex items-center gap-2" data-id="element-370">
                <svg className="w-4 h-4 text-gold" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-371">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" data-id="element-372" />
                </svg>
                Léelo en celular, tablet o computadora
              </span>
              <span className="flex items-center gap-2" data-id="element-373">
                <svg className="w-4 h-4 text-gold" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-374">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-375" />
                </svg>
                Pago seguro · Acceso de por vida
              </span>
            </div>

            {/* Price Display */}
            <div className="mb-8 flex flex-col items-center md:items-start" data-id="element-376">
              <div className="flex items-baseline gap-3 mb-1" data-id="element-377">
                <span className="font-sans text-gray-warm line-through text-lg" data-id="element-378">
                  $27
                </span>
                <span className="font-serif font-bold text-gold text-4xl" data-id="element-379">
                  $17.95
                </span>
              </div>
              <span className="font-mono text-[11px] text-gray-warm uppercase tracking-wider mb-1" data-id="element-380">
                Oferta por tiempo limitado
              </span>
              <span className="font-sans text-sm text-green font-medium" data-id="element-381">
                Ahorro inmediato de $9.05
              </span>
            </div>

            {/* CTA */}
            <div className="w-full max-w-md flex flex-col items-center md:items-start" data-id="element-382">
              <a href="https://www.godeskcore.com/cart/42794527916080:1" target="_blank" rel="noopener noreferrer" onClick={onAddToCart} className="w-full bg-gold hover:bg-[#D4B355] text-dark-primary font-sans font-bold text-lg py-5 px-8 rounded-md transition-all text-center shadow-[0_0_20px_rgba(201,168,76,0.2)] hover:shadow-[0_0_30px_rgba(201,168,76,0.4)] hover:-translate-y-0.5" data-id="element-383">
                QUIERO MI COPIA AHORA — $17.95
              </a>
              <p className="mt-4 font-sans text-[12px] text-gray-warm text-center md:text-left leading-relaxed" data-id="element-384">
                PDF digital · Descarga inmediata ·{' '}
                <br className="hidden md:block" data-id="element-385" />
                Acceso de por vida · No se requiere envío
              </p>
              <a href="#bonuses" className="mt-4 font-sans text-sm text-gold underline underline-offset-4 hover:text-cream transition-colors" data-id="element-386">
                Ver qué incluye ↓
              </a>
            </div>
          </div>

          {/* RIGHT COLUMN */}
          <div className="w-full md:w-[40%] relative flex flex-col items-center justify-center mt-8 md:mt-0" data-id="element-387">
            {/* Ambient Glow */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[250px] h-[350px] bg-gold/10 blur-[60px] rounded-full pointer-events-none" data-id="element-388"></div>

            {/* 3D Book */}
            <div className="relative w-[220px] md:w-[280px] z-10 transition-transform duration-700 hover:scale-105" style={{
            transform: 'rotateY(-15deg) rotateX(5deg) rotateZ(2deg)',
            transformStyle: 'preserve-3d',
            perspective: '1000px'
          }} data-id="element-389">
              {/* Spine */}
              <div className="absolute top-0 left-0 bottom-0 w-4 bg-gradient-to-r from-[#0a0a0a] to-[#1a1a1a] rounded-l-sm" style={{
              transform: 'translateZ(-2px) translateX(-2px)'
            }} data-id="element-390"></div>

              <img src="https://cdn.magicpatterns.com/uploads/x4XZTN8gQQCc5QtzEW7QdL/Portada_Ebook_Principal.png" alt="El Azúcar Silencioso" className="w-full h-auto rounded-sm relative z-10" style={{
              boxShadow: '25px 25px 50px -12px rgba(0,0,0,0.8), 0 0 0 1px rgba(201,168,76,0.1)'
            }} data-id="element-391" />
            </div>

            {/* Bonus Thumbnails */}
            <div className="flex items-center justify-center gap-[-10px] mt-8 relative z-20" data-id="element-392">
              <img src="https://cdn.magicpatterns.com/uploads/2g8fWemRTNhKHrzpLvZY2y/Portada_Bono_1.png" alt="Bono 1" className="w-16 md:w-20 rounded-sm shadow-xl border border-border-subtle transform -rotate-6 translate-x-4" data-id="element-393" />
              <img src="https://cdn.magicpatterns.com/uploads/fGywZHm5sAFxTJ8HRHrKV3/Portada_Bono_2.png" alt="Bono 2" className="w-16 md:w-20 rounded-sm shadow-xl border border-border-subtle z-10" data-id="element-394" />
              <img src="https://cdn.magicpatterns.com/uploads/mFQ4EuLTn6r2WXq5jT4qZ1/Portada_Bono_3.png" alt="Bono 3" className="w-16 md:w-20 rounded-sm shadow-xl border border-border-subtle transform rotate-6 -translate-x-4" data-id="element-395" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}